import { CSSObject } from '@gsc/types'
import { useRegisterStyle } from './useRegisterStyle'
import { useMemo } from 'preact/hooks'

interface Styled {
  id?: string
  className?: string
  css?: CSSObject
}

interface UseComponentStyle {
  classes: string[]
}

export function useComponentStyle(name: string, styled: Styled): UseComponentStyle {
  const { id: baseId, className, css } = styled ?? {}
  const id = baseId ? (baseId.startsWith(name) ? baseId : `${name}-${baseId}`) : ''

  const style = useMemo(() => {
    return name && id && css ? { id, selector: `.${name}:where(.${id})`, css } : null
  }, [name, id, css])

  useRegisterStyle(style)

  return { classes: [className, name, id].filter(Boolean) }
}
